module.exports = __webpack_public_path__ + "b82969f8a99c585e95885dcc6586b163.svg";